import React, { Component } from 'react'
import 'worldwindjs'
// import axios from 'axios';
import request from '../../utils/request'
import { osintRequestAddress } from '../config'

/* global WorldWind */
export default class ShipsLayer extends Component{
    state = {
        isShipListGot: false,
    }
    // 舰船图标配置
    static shipIcons = [
        // "https://files.worldwind.arc.nasa.gov/artifactory/web/0.9.0/images/pushpins/castshadow-red.png",
        "./greyship.png",
        "./blackship.png",
        "./blueship.png",
    ];

    componentDidMount(){
        if (this.state.isShipListGot){
            return
        }  
        // Create a placemark using the selected marker image
        let attributes = new WorldWind.PlacemarkAttributes(null);
        attributes.imageScale = 0.8;
        attributes.imageOffset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 0.35);
        attributes.imageColor = WorldWind.Color.WHITE;
        attributes.labelAttributes.offset = new WorldWind.Offset(
            WorldWind.OFFSET_FRACTION, 0.5,
            WorldWind.OFFSET_FRACTION, 1.0);
        attributes.labelAttributes.color = WorldWind.Color.YELLOW;
        attributes.labelAttributes.scale = 2.5;
        attributes.drawLeaderLine = true;
        attributes.leaderLineAttributes.outlineColor = WorldWind.Color.RED;
        attributes.imageSource = ShipsLayer.shipIcons[0];

        const token = localStorage.getItem('token')
        // axios({
        //     method: "get",
        //     url: "https://www.osintsee.com/ship?qcode=alllocs",
        //     headers: {
        //         'Authorization': token,
        //     },
        // }).
        request({
            url: `${osintRequestAddress}/ship?qcode=alllocs`,
            headers: {
                'Authorization': token,
            },
            method: 'get',
        }).then(
            response => {
                if (response && response.length>0){
                    response.map(
                    // 为调试方便，仅取前5艘船
                    // response.slice(0,4).map(
                        (ship) => {
                            // var position = {latitude:ship.lat,longitude:ship.lon,altitude:0}
                            var position = {latitude:ship.lat+Math.random()-0.5,longitude:ship.lon+Math.random()-0.5,altitude:0}    //添加随机偏移，防止舰船显示堆叠
                            let placemark = new WorldWind.Placemark(position, /*eyeDistanceScaling*/ true, attributes);
                            placemark.type = 'ship'
                            placemark.label = ship.shipName;
                            placemark.altitudeMode = WorldWind.CLAMP_TO_GROUND;
                            placemark.eyeDistanceScalingThreshold = 2500000;
                            placemark.eyeDistanceScalingLabelThreshold = 25000000;
                            // Add the placemark to the layer and to the Markers component
                            const globe = this.props.globe;                            
                            const layer = globe.getLayer(this.props.markersLayerName);
                            if (layer) {
                                // Add the placemark to the globe
                                layer.addRenderable(placemark);  
                                // send the placemark to the Markers component                            
                                this.props.addShip(placemark, ship)
                            } else {
                                console.warn("Renderable layer for markers not found: "+ this.props.markersLayerName);
                            }

                            return ""                   
                        }                        
                    )                   
                    this.setState({ isShipListGot:true })
                }
            },
            error => {console.log("error",error)}
        )
    } 

    render(){
        return <div></div>
    }
}
